export const styles = (theme) => ({
  confirmationTextField: {
    marginTop: theme.spacing(1),
  },
  cancelButton: {
    fontWeight: 500,
    whiteSpace: 'nowrap',
    height: 36,
    color: theme.palette.secondary.main,
  },
  tertiary: {
    marginRight: 'auto',
  },
});
